
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.003 1.911l9.398 4.7 2.338 10.633-6.53 8.503H8.796l-6.529-8.503L4.603 6.611zm11.033 3.445L14.003-.16 2.969 5.356.26 17.679l7.61 9.907h12.265l7.61-9.907z"}}),_c('path',{attrs:{"d":"M20.716 11.495s.13 1.064.13 2.128v.998c0 1.064-.13 2.128-.13 2.128s-.127.906-.52 1.305c-.496.524-1.053.527-1.308.557-1.829.133-4.575.138-4.575.138s-3.397-.032-4.442-.132c-.291-.056-.944-.039-1.44-.563-.393-.399-.52-1.305-.52-1.305s-.131-1.064-.131-2.128v-.998c0-1.064.13-2.128.13-2.128s.128-.906.52-1.305c.497-.524 1.054-.526 1.31-.557 1.828-.133 4.57-.133 4.57-.133h.006s2.743 0 4.572.133c.255.03.812.033 1.309.557.392.399.52 1.305.52 1.305zm-4.218 2.494l-3.538-1.854v3.695z"}})])
          )
        }
      }
    